import { AspectRatio, Button, Flex } from "@chakra-ui/react"
import dynamic from "next/dynamic"
import ReactPlayer from "react-player/youtube"
import { VideoModel } from "../../../../../api-clients/product-api-v1"
import { cookieSolutionServices } from "../../../../../common/constants/constants"
import { useBrandedTranslation } from "../../../../../common/hooks/useBrandedTranslation"
import useConsentStatus from "../../../../../common/hooks/useConsentStatus"
import PlayButton from "./PlayButton"

const RichTextLabel = dynamic(() => import("../../../../../../src/components/shared/RichTextLabel"), {
  ssr: false,
})

type Props = {
  videos: VideoModel[]
}

const Videos = ({ videos }: Props) => {
  const { t } = useBrandedTranslation()
  const youtubeConsented = useConsentStatus(cookieSolutionServices.YOUTUBE_VIDEO)

  return (
    <Flex gap={{ base: "4", xs: "6" }} flexWrap="wrap">
      {videos.map((video: VideoModel) => {
        return (
          <AspectRatio
            key={video.youtubeID}
            w="100%"
            // maxWidth 50% doesn't work well when we have a "gap" set in the parent container,
            // that's why we remove half the value of the gap from the maxWidth
            maxW={{ base: "100%", md: "calc(50% - 12px)" }}
            ratio={16 / 9}
          >
            {youtubeConsented ? (
              <ReactPlayer
                width="100%"
                height="100%"
                controls={true}
                light={`https://i.ytimg.com/vi/${video.youtubeID}/hqdefault.jpg`}
                url={`https://www.youtube.com/embed/${video.youtubeID}`}
                playing={true}
                playIcon={<PlayButton />}
              />
            ) : (
              <Flex
                flexDirection="column"
                align="center"
                justifyContent="center"
                backgroundColor="gray.900"
                px="6"
                py="7.5"
              >
                <RichTextLabel
                  i18nKey={"cookie-youtube-activate_rtf"}
                  styleProps={{
                    sx: {
                      h3: {
                        color: "baseWhite",
                        fontSize: "4xl",
                        fontWeight: "light",
                        textAlign: "center",
                      },
                      p: {
                        color: "baseWhite",
                        fontSize: "md",
                        textAlign: "center",
                        my: 6,
                      },
                      a: {
                        textDecoration: "underline",
                      },
                    },
                  }}
                />

                <Button
                  minH={{ base: "11", lg: "10" }}
                  variant="primary"
                  onClick={() => {
                    window.UC_UI.acceptService(cookieSolutionServices.YOUTUBE_VIDEO)
                  }}
                >
                  {t("cookie-youtube-activate-button")}
                </Button>
              </Flex>
            )}
          </AspectRatio>
        )
      })}
    </Flex>
  )
}

export default Videos
